'use client'
import React from "react";
import { useAuth } from "./with-auth";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import dynamic from "next/dynamic";
import {Rfs__all} from "../../_refs/Rfs__all";
const Loading = dynamic(() => import('@/components/layout/page-loader'), { ssr: false });

export const WithAuth = ({ children }: { children: React.ReactNode }) => {
    const { user, loading } = useAuth();
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const keywords = ['/home', '/packages', '/consultation/new-session', '/programs/list', '/programs/program-details', '/programs/university-details', '/admission-chance'];
    React.useEffect(() => {
        if (!user && !loading) {
            Rfs__all.middlewareAuth();
            if (!keywords.some(keyword => pathname?.includes(keyword))) {
                window.setTimeout(() => {
                    const search = searchParams?.toString();
                    const targetPath = pathname ?? "/";
                    const callbackCandidate = search ? `${targetPath}?${search}` : targetPath;
                    const shouldAttachCallback = callbackCandidate && !callbackCandidate.startsWith("/login");
                    if (shouldAttachCallback) {
                        const encoded = encodeURIComponent(callbackCandidate);
                        router.push(`/login?callbackUrl=${encoded}`);
                    } else {
                        router.push("/login");
                    }
                }, 100)
            }
        }
    }, [user, router, loading, pathname, searchParams]);


    if (loading) {
        return <div className="h-screen"><Loading /></div>;
    }

    return <>{children}</>
};


